module.exports = __webpack_public_path__ + "static/media/courtyard2.545b66d6.jpeg";